import { z } from 'zod';
import { zGoNullableDate, zGoSlice } from '../helpers/fix-go-types';
import { SalesTotalSchema } from './sales-total';
import { YearSalesSchema } from './year-sales';

const CurrentYearEstimatesSchema = z.object({
  totals: SalesTotalSchema,
  monthly: z.array(SalesTotalSchema),
});

export type CurrentYearEstimates = z.infer<typeof CurrentYearEstimatesSchema>;

// form validation rules
export const StoreSalesStatsSchema = z.object({
  // Go serializes a nil `[]YearSalesStats` (no omitempty) as `null`; zGoSlice
  // coerces null → [] so a store with no sales history isn't dropped by
  // validation.
  historical: zGoSlice(YearSalesSchema),
  current_year_estimates: CurrentYearEstimatesSchema,
  // `LastTransactionDate time.Time` is a bare value with neither omitempty nor
  // omitzero (models/stores.go:125), so a store with no transactions carries
  // Go's zero time — "0001-01-01T00:00:00Z" — on the wire. zGoNullableDate maps
  // it to null, which is what every reader already assumes: the dashboard's
  // `last_transaction_date || updated_at` was written for a falsy no-value, and
  // useImportMonth measures staleness in months since the date, so a year-1
  // Date reported the store's data as ~24,000 months stale instead of falling
  // back to updated_at. The API agrees a zero here means "none" — mcp_tools.go
  // omits the field entirely when IsZero().
  last_transaction_date: zGoNullableDate,
});
